import { Stack } from 'canoe';
import React from 'react';

import {
  SelectorProps,
} from 'craft/containers/Toolbox/tabs/Placements/InlinePlacements/components/InlineSelector/InlineSelector';
import { StepTitle } from 'craft/containers/Toolbox/tabs/Placements/components/ui';

import { InlineSelector } from './InlineSelector';
import { InlineUrl } from './InlineURL';

interface StepTwoProps {
  onEditUrl: VoidFunction;
  onEditSelector: VoidFunction;
}

export const FormStep1 = ({
  onEditUrl,
  onEditSelector,
  ...selectorProps
}: StepTwoProps & Omit<SelectorProps, 'onEdit'>) => {
  return (
    <div>
      <StepTitle size="short">1. Where will your Content go?</StepTitle>

      <Stack spaceAfter="normal">
        <InlineSelector onEdit={onEditSelector} {...selectorProps} />
        <InlineUrl onEdit={onEditUrl} />
      </Stack>
    </div>
  );
};
